import * as React from "react";
import { Segment, Grid, Header, Button, List, GridRow, GridColumn, ListItem, ListHeader } from "@/components/bp/bp-ui";
import { TranslationContext } from "../Contexts/TranslationContext";
import { ClientResources, MaxLrCaseRunCreateModelBase, RunParameterModel } from "@app/api2/api";
import { ParametersView } from "./ParametersView";
import { HandlerRegistry } from "./RunTypes/HandlerRegistry";
import { BPFormError } from "@common/BPFormError";
import { insertComponentsIntoText, isNullOrWhitespace } from "@common/Utils";
import { BPButton } from "@/components/bp/bpbutton";

interface IReviewMaxLrProps {
    model: MaxLrCaseRunCreateModelBase;
    onComplete: (values: any) => void;
    router: any;
}

class ReviewMaxLrState {

}

export class ReviewMaxLr extends React.Component<IReviewMaxLrProps, ReviewMaxLrState> {
    
    constructor(props, context) {
        super(props, context);

        this.state = {

        };

    }

    isRowVisible = (p: RunParameterModel) => {
        if (!p.userVisible) {
            return false;
        }
        if (!p.showIfChecked) {
            return true;
        }

        var fields = p.showIfChecked.split(',');

        var falseFields = fields.filter(f => f.startsWith("!")).map(m => m.slice(1));
        var trueFields = fields.filter(f => !f.startsWith("!"));

        var values = this.props.model.parameters.reduce((dict, curr) => {
            dict[curr.parameter] = curr.value;
            return dict;
        }, {});

        return falseFields.reduce((show, field) => show && !(values[field] === "1"), true) && trueFields.reduce((show, field) => show && (values[field] === "1"), true);
    };


    parameterRenderer = () => {
        return this.getRunTypeHandler(this.props.model.runType);
    }

    getRunTypeHandler(runType: string) {
        return HandlerRegistry.getRunTypeHandler(runType);
    }


    render() {
        const population = this.props.model.populations.find((p) => (p.id === this.props.model.populationId));
        return (<TranslationContext.Consumer>{t =>
            <div>
                <Grid columns={4}>
                    <GridRow>
                        <GridColumn>
                            <Header attached="top">{t.caseRun.general}</Header>
                            <Segment attached>
                                <List>
                                    <ListItem>
                                        <ListHeader>{t.common.population}</ListHeader>
                                        {population != null ? population.name : ""}
                                    </ListItem>
                                </List>
                            </Segment>
                        </GridColumn>
                        {this.props.model.useHp &&
                            <GridColumn>
                                <Header attached="top">{this.props.model.useHp && this.props.model.useHd ? t.caseRun.contributorsInHp : t.common.contributors}</Header>
                                <Segment attached>
                                    <List>
                                        {this.props.model.hp.filter((p) => (p.selected)).map((p) => (
                                            <ListItem key={p.id}>{p.name}</ListItem>
                                        ))}
                                        <ListItem>
                                            {t.caseRun.unknowns}: {this.props.model.hpUnknowns}
                                        </ListItem>
                                    </List>
                                </Segment>
                            </GridColumn>
                        }
                        {this.props.model.useHd &&
                            <GridColumn>
                                <Header attached="top">{t.caseRun.contributorsInHd}</Header>
                                <Segment attached>
                                    <List>
                                        {this.props.model.hd.filter((p) => (p.selected)).map((p) => (
                                            <ListItem key={p.id}>{p.name}</ListItem>
                                        ))}
                                        <ListItem>
                                            {t.caseRun.unknowns}: {this.props.model.hdUnknowns}
                                        </ListItem>
                                        <ListItem>
                                            {!isNullOrWhitespace(this.props.model.hdKnownRelName) && <div>
                                                {insertComponentsIntoText(t.caseRunView.firstUnknownRelation, {
                                                    '{relationName}': this.props.model.hdKnownRelName
                                                })}&nbsp;
                                                <span>{this.props.model.hd.find(x => x.id == this.props.model.hdKnownRelSampleId)?.name}</span>
                                            </div>}
                                        </ListItem>

                                    </List>
                                </Segment>
                            </GridColumn>
                        }
                        {this.props.model.evidence?.find(c=>c.selected) && <GridColumn>
                            <Header attached="top">{t.common.evidence}</Header>
                            <Segment attached>
                                <List>
                                    {this.props.model.evidence.filter((p) => (p.selected)).map((p) => (
                                        <ListItem key={p.id}>{p.name}</ListItem>
                                    ))}
                                </List>
                            </Segment>
                        </GridColumn>}
                    </GridRow>
                </Grid>
                <Header attached="top">{t.common.parameters}</Header>
                <Segment attached>
                    <ParametersView parameters={this.props.model.parameters} parameterRenderer={this.parameterRenderer()} model={{ ...this.props.model, efmCaseId: this.props.model.efmCaseId }} />
                </Segment>
                <Segment basic clearing>
                    <BPButton floated="right" type="submit" onClick={this.props.onComplete} positive primary>{t.caseRun.queueRun}</BPButton>
                </Segment>
            </div>}</TranslationContext.Consumer>);
    }
}